// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { X } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconX(props: any) {
    return <IconBase icon={X} {...props} />
  }

  export default IconX
  